export default __webpack_public_path__ + "static/banner-87608c2bfa7c9c53c98522cba3a8ee6b.png";